import autoTable from 'jspdf-autotable';
import title from '../../../helpers/title';

// CONSTANTS
import {
  PERU_NATIONAL_ID,
  PERU_RESIDENTIAL,
  PERU_TAX_REGISTRATION,
} from '../peruConstants';

const errorMessages = (doc, data, info, docStyles) => {
  const { serviceResponses } = data.Response;

  title(
    doc,
    docStyles,
    'Error Message(s)',
    docStyles.headers.primary,
    docStyles.separation,
    true // PRIMARY HEADER STYLES
  );

  const columnsBody = [
    { title: '', dataKey: 'col1' },
    {
      title: '',
      dataKey: 'col2',
    },
  ];
  const rowsBody = [];

  // DATA SOURCE RESPONSE
  let nationalIDNumber = serviceResponses[PERU_NATIONAL_ID];
  let residential = serviceResponses[PERU_RESIDENTIAL];
  let taxRegistration = serviceResponses[PERU_TAX_REGISTRATION];
  let watchlistAML = serviceResponses['Watchlist AML'];

  // NATIONAL ID
  if (nationalIDNumber) {
    let status;
    if (nationalIDNumber.status === 3) {
      status = nationalIDNumber.errorMessage
        ? nationalIDNumber.errorMessage
        : 'Error at Data Source';
    } else {
      status = 'N/A';
    }
    rowsBody.push({
      col1: PERU_NATIONAL_ID,
      col2: status,
    });
  } else {
    nationalIDNumber = { verifications: {}, returnedData: {} };
  }

  // RESIDENTIAL
  if (residential) {
    let status;
    if (residential.status === 3) {
      status = residential.errorMessage
        ? residential.errorMessage
        : 'Error at Data Source';
    } else {
      status = 'N/A';
    }
    rowsBody.push({
      col1: PERU_NATIONAL_ID,
      col2: status,
    });
  } else {
    residential = { verifications: {}, returnedData: {} };
  }

  // TAX REGISTRATION
  if (taxRegistration) {
    let status;
    if (taxRegistration.status === 3) {
      status = taxRegistration.errorMessage
        ? taxRegistration.errorMessage
        : 'Error at Data Source';
    } else {
      status = 'N/A';
    }
    rowsBody.push({
      col1: PERU_NATIONAL_ID,
      col2: status,
    });
  } else {
    taxRegistration = { verifications: {}, returnedData: {} };
  }

  // WATCHLIST AML
  if (watchlistAML) {
    let status;
    if (watchlistAML.status === 3) {
      status = watchlistAML.errorMessage
        ? watchlistAML.errorMessage
        : 'Error at Data Source';
    } else {
      status = 'N/A';
    }
    rowsBody.push({
      col1: 'Global Watchlist AML',
      col2: status,
    });
  } else {
    watchlistAML = { verifications: {}, returnedData: {} };
  }

  const finalY = (doc.lastAutoTable.finalY || 40) + docStyles.tableYFromTitle;

  autoTable(doc, {
    columnsBody,
    rowsBody,
    didParseCell: (data) => {
      const { cell, column } = data;
      cell.styles.fillColor = [255, 255, 255];
      if (column.raw.dataKey === 'col1') {
        cell.styles.textColor = docStyles.color;
      }
    },
    showHead: 'never',
    styles: {
      textColor: docStyles.colorText,
      font: docStyles.fontFamily.time,
      ...docStyles.tableStyles,
    },
    columnStyles: {
      col1: {
        font: docStyles.fontFamily.time,
        textColor: docStyles.colorText,
        cellWidth: docStyles.cellWidth,
      },
      col2: {
        font: docStyles.fontFamily.time,
        textColor: docStyles.colorText,
      },
    },
    // margin: { bottom: 100 }, // PREVENTS OVERLAP WITH FOOTER
    startY: finalY,
  });
};

export default errorMessages;
